module.exports = __webpack_public_path__ + "img/green-asterisk-01.69bf39cb.png";